// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__G2uJ7","games_section_title":"notification_games_section_title__al48I"};